import { Button, Col, Row, Spinner } from "reactstrap";
import ICVImageViewComponent from "../../../components/ICVImageViewComponent";
import { ICVActivitiesFormDetails } from "./ICVActivitiesFormDetails";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiService from "../../../api/serviceApi";
import ICVActivityQCForm from "../icvQCActivities/ICVActivityQCForm";
import { handleICVStatusUpdateSlice, handleOnHoldSurveySlice } from "../../../redux/slices/icvActivitySlice";
import { handleUpdatePageSlice, handleFormSubmittedSlice } from "../../../redux/slices/globalSlice";
import { handleCHMInfoByIdDataSlice } from "../../../redux/slices/chmActivitySlice";
import BackArrow from "../../../assets/img/back-arrow.svg";
import "./ICVStyles.css";
import { IconButton } from "@mui/material";
import { ICV_STATUS } from "../../../utils/Constant";
import { loginSelector } from "../../../redux/slices/loginSlice";
import { LoggedUserType } from "../../../models/GlobalModels";
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CHMActivityMap from "../chmActivities/CHMActivityMap";

// Image Loader Component
const ImageLoader = ({ text }: { text: string }) => (
  <div className="p-2">
    <div className="image-loader-container">
      <Spinner className="image-loader-spinner">
        Loading...
      </Spinner>
    </div>
    <div className="image-loader-text-container">
      <text className="image-loader-text">{text}</text>
    </div>
  </div>
);

const ICVFormDetails = (
  { storeICVFormData, showQCDetails }: any,
) => {
  const dispatch: any = useDispatch();
  const [westImagepath, setWestImagepath] = useState<any>("");
  const [eastImagepath, setEastImagepath] = useState<any>("");
  const [northImagepath, setNorthImagepath] = useState<any>("");
  const [southImagepath, setSouthImagepath] = useState<any>("");
  const [selectedStatus, setSelectedStatus] = useState<'Reassigned' | 'Completed' | 'On_Hold'| 'Qc_In_Progress' | 'Reassigned_From_Hold' | null>(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
  const [formDisabled, setFormDisabled] = useState<boolean>(true);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [imagesLoading, setImagesLoading] = useState<boolean>(true);
  const [onHoldSelected, setOnHoldSelected] = useState<string>("");
  const formRef = useRef<any>(null);

  const { storeICVStatusUpdateRes, storeICVOnHoldRes } = useSelector((state: any) => state.icvActivity);
  const user: LoggedUserType = useSelector(loginSelector).user;

  useEffect(() => {
    loadAllImages();
  }, []);

  const loadAllImages = async () => {
    setImagesLoading(true);
    try {
      await Promise.all([
        getWestImages(),
        getEastImages(),
        getNorthImages(),
        getSouthImages()
      ]);
    } finally {
      setImagesLoading(false);
    }
  };

  const getWestImages = async () => {
    try {
      const westImg = await apiService("get", "/azure-file-service/v1.1/get_doc/" + storeICVFormData.westImgPath);
      setWestImagepath(westImg?.data?.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getEastImages = async () => {
    try {
      const eastImag = await apiService("get", "/azure-file-service/v1.1/get_doc/" + storeICVFormData.eastImgPath);
      setEastImagepath(eastImag?.data?.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getNorthImages = async () => {
    try {
      const northImag = await apiService("get", "/azure-file-service/v1.1/get_doc/" + storeICVFormData.northImgPath);
      setNorthImagepath(northImag?.data?.response);
    } catch (error) {
      console.error(error);
    }
  };

  const getSouthImages = async () => {
    try {
      const southImag = await apiService("get", "/azure-file-service/v1.1/get_doc/" + storeICVFormData.southImgPath);
      setSouthImagepath(southImag?.data?.response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (storeICVStatusUpdateRes?.statusCode === 1 && storeICVStatusUpdateRes?.data === 1) {
      setIsSubmitting(false);
      dispatch(handleICVStatusUpdateSlice({}));
      dispatch(handleFormSubmittedSlice(true));
      dispatch(handleUpdatePageSlice(false));
      dispatch(handleCHMInfoByIdDataSlice({}));
    }
  }, [storeICVStatusUpdateRes]);

  useEffect(() => {
    if (storeICVOnHoldRes?.statusCode === 1) {
      setIsSubmitting(false);
      dispatch(handleOnHoldSurveySlice({}));
      dispatch(handleFormSubmittedSlice(true));
      dispatch(handleUpdatePageSlice(false));
      dispatch(handleCHMInfoByIdDataSlice({}));
    }
  }, [storeICVOnHoldRes]);

  const handleBack = () => {
    dispatch(handleFormSubmittedSlice(false));
    dispatch(handleUpdatePageSlice(false));
    dispatch(handleCHMInfoByIdDataSlice({}));
  };

  // Disable form if not QC in progress
  useEffect(() => {
    if (storeICVFormData?.icvStatusId === ICV_STATUS.QC_IN_PROGRESS || storeICVFormData?.icvStatusId === ICV_STATUS.ON_HOLD) {
      setFormDisabled(false);
    } else {
      setFormDisabled(true);
    }
  }, [storeICVFormData]);

  const handleReassign = () => {
    setSelectedStatus('Reassigned');
    const qcSection = document.getElementById('qc-section');
    if(qcSection){
      qcSection.scrollIntoView({behavior: 'smooth'});
    }
    if(isFormValid) {
      setIsFormSubmitted(true);
    }
  };

  const handleReassignFromHold = () => {
     setSelectedStatus("Reassigned_From_Hold");
     const qcSection = document.getElementById("qc-section");
     if (qcSection) {
       qcSection.scrollIntoView({ behavior: "smooth" });
     }
     if (isFormValid) {
       setIsFormSubmitted(true);
     }
  }

   const handleQCprogress = () => {
     setSelectedStatus("Qc_In_Progress");
     const qcSection = document.getElementById("qc-section");
     if (qcSection) {
       qcSection.scrollIntoView({ behavior: "smooth" });
     }
     if (isFormValid) {
       setIsFormSubmitted(true);
     }
   };

  const handleonhold = () => {
    setSelectedStatus('On_Hold');
    const qcSection = document.getElementById('qc-section');
    if(qcSection){
      qcSection.scrollIntoView({behavior: 'smooth'});
    }
    if(isFormValid) {
      setIsFormSubmitted(true);
    }
  };

  const handleSubmitQC = () => {
    setSelectedStatus('Completed');
    const qcSection = document.getElementById('qc-section');
    if(qcSection){
      qcSection.scrollIntoView({behavior: 'smooth'});
    }
    if(isFormValid) {
      setIsFormSubmitted(true);
    }
  };

  useEffect(() => {
    if (formRef.current && isFormSubmitted && (selectedStatus && selectedStatus?.length > 0)) {
      formRef.current.submitForm();
    }
  },[selectedStatus, isFormSubmitted])

  useEffect(() => {
    const scrollableContainer = document.querySelector('div[style*="overflow: auto"]');
    if (scrollableContainer) {
      scrollableContainer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="w-100">
      <div className="d-flex justify-space-between align-items-center mb-3 w-100">
        <IconButton onClick={() => handleBack()}>
          <img src={BackArrow} className="back-arrow-icon" />
        </IconButton>
        <span className="mx-2 fw-bold kml-id-text">
          KML ID - {storeICVFormData?.kmlId}
        </span>
      </div>

      <div className="d-flex w-100 gap-4 icv-form-layout">
        <div
          className="left-content-section"
          style={{
            marginBottom:
              showQCDetails &&
              (storeICVFormData?.icvStatusId === ICV_STATUS.COMPLETED ||
                storeICVFormData?.icvStatusId === ICV_STATUS.QC_IN_PROGRESS ||
                storeICVFormData?.icvStatusId === ICV_STATUS.ON_HOLD) &&
              !formDisabled &&
              user?.permissions?.includes("Quality-Check-feedback")
                ? "60px"
                : "0",
          }}
        >
          <div
            className={`crop-details-container 
            ${![ICV_STATUS.QC_IN_PROGRESS, ICV_STATUS.COMPLETED, ICV_STATUS.ON_HOLD].includes(storeICVFormData?.icvStatusId) ? "crop-section" : ""}
            `}
          >
            <ICVActivitiesFormDetails
              storeICVData={storeICVFormData}
              showQCDetails={showQCDetails}
            />
          </div>
          {showQCDetails &&
            (storeICVFormData?.icvStatusId === ICV_STATUS.COMPLETED ||
              storeICVFormData?.icvStatusId === ICV_STATUS.QC_IN_PROGRESS ||
              storeICVFormData?.icvStatusId === ICV_STATUS.ON_HOLD) && (
              <div
                className="qc-feedback-container"
                id="qc-section"
                style={formDisabled ? {} : { marginBottom: "20px" }}
              >
                <p className="section-header">QC Feedback</p>
                <div className="px-4 pb-4 mx-2">
                  <ICVActivityQCForm
                    ref={formRef}
                    formData={storeICVFormData}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                    setIsFormValid={setIsFormValid}
                    setIsSubmitting={setIsSubmitting}
                    onHoldChange={(value: string) => setOnHoldSelected(value)}
                  />
                </div>
              </div>
            )}
          <div className="mt-4 rounded-2xl overflow-hidden">
            <CHMActivityMap
              mapData={{
                lat: Number(storeICVFormData?.lat),
                lng: Number(storeICVFormData?.lng),
                polygonCentroid: storeICVFormData?.polygonCentroid,
                polygon: storeICVFormData?.polygon,
                surveyNumber: storeICVFormData?.surveyNumber,
                cropName: storeICVFormData?.cropNameAsPerField,
                villageName: storeICVFormData?.villageName,
                imageCoordinates: storeICVFormData?.imageCoordinates,
              }}
            />
          </div>
        </div>
        <div
          className="farm-photo-container"
          style={{
            marginBottom:
              showQCDetails &&
              !formDisabled &&
              user?.permissions?.includes("Quality-Check-feedback")
                ? "80px"
                : "0",
          }}
        >
          <p className="section-header">Farm Photos</p>
          <div className="farm-photos-content">
            <Row style={{ margin: "0 2%", padding: "2%" }}>
              <Col md={12} sm={12} lg={12} className="p-0">
                {imagesLoading ? (
                  <ImageLoader text="East Corner" />
                ) : (
                  eastImagepath && (
                    <ICVImageViewComponent
                      text="East Corner"
                      imagePath={eastImagepath}
                    />
                  )
                )}
              </Col>
              <Col md={12} sm={12} lg={12} className="p-0">
                {imagesLoading ? (
                  <ImageLoader text="West Corner" />
                ) : (
                  westImagepath && (
                    <ICVImageViewComponent
                      text="West Corner"
                      imagePath={westImagepath}
                    />
                  )
                )}
              </Col>
              <Col md={12} sm={12} lg={12} className="p-0">
                {imagesLoading ? (
                  <ImageLoader text="North Corner" />
                ) : (
                  northImagepath && (
                    <ICVImageViewComponent
                      text="North Corner"
                      imagePath={northImagepath}
                    />
                  )
                )}
              </Col>
              <Col md={12} sm={12} lg={12} className="p-0">
                {imagesLoading ? (
                  <ImageLoader text="South Corner" />
                ) : (
                  southImagepath && (
                    <ICVImageViewComponent
                      text="South Corner"
                      imagePath={southImagepath}
                    />
                  )
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Footer with buttons */}
      {!formDisabled &&
        user?.permissions?.includes("Quality-Check-feedback") && (
          <div className="icv-form-footer">
            <div className="d-flex justify-content-end">
              {storeICVFormData?.icvStatusId === ICV_STATUS.ON_HOLD ? (
                <>
                  <Button
                    variant="contained"
                    className={`mx-2 ${isFormValid && !isSubmitting ? "cl-btn-outline-primary" : "cl-btn-outline-primary-disabled"}`}
                    onClick={handleReassignFromHold}
                    disabled={isSubmitting}
                  >
                    Reassign Survey
                    <AssignmentLateIcon className="ms-2" />
                  </Button>

                  <Button
                    variant="contained"
                    className={`mx-2 ${isFormValid && !isSubmitting ? "cl-btn-primary" : "cl-btn-primary-disabled"}`}
                    onClick={handleQCprogress}
                    disabled={isSubmitting}
                  >
                    QC Inprogress
                    <AssignmentTurnedInIcon className="ms-2" />
                  </Button>
                </>
              ) : onHoldSelected === "yes" ? (
                // OnHold = yes → only this button
                <Button
                  variant="contained"
                  className={
                    isFormValid && !isSubmitting
                      ? "cl-btn-outline-primary"
                      : "cl-btn-outline-primary-disabled"
                  }
                  onClick={handleonhold}
                  disabled={isSubmitting}
                >
                  On Hold
                </Button>
              ) : (
                // OnHold = no → show the two QC buttons
                <>
                  <Button
                    variant="contained"
                    className={`mx-2 ${isFormValid && !isSubmitting ? "cl-btn-outline-primary" : "cl-btn-outline-primary-disabled"}`}
                    onClick={handleReassign}
                    disabled={isSubmitting}
                  >
                    Reassign Survey
                    <AssignmentLateIcon className="ms-2" />
                  </Button>

                  <Button
                    variant="contained"
                    className={`mx-2 ${isFormValid && !isSubmitting ? "cl-btn-primary" : "cl-btn-primary-disabled"}`}
                    onClick={handleSubmitQC}
                    disabled={isSubmitting}
                  >
                    Submit QC
                    <AssignmentTurnedInIcon className="ms-2" />
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
    </div>
  );
};

export default ICVFormDetails;